import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, Loader2, Printer } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { QuoteDocView, docTitle } from "@/components/quote/QuoteDocView";
import { api, errMsg, useApi } from "@/lib/api";

export default function QuotePreview() {
  const { token } = useParams();
  const { data, reload, loading } = useApi(`/public/quote/${token}`);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (data) document.title = docTitle(data); }, [data]);
  const approve = async () => {
    setBusy(true);
    try { await api.post(`/public/quote/${token}/approve`); toast.success("Thank you! Your quotation is approved."); reload(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-zinc-100 py-4 sm:py-8 px-2 sm:px-4 text-zinc-900">
      <div className="max-w-[794px] mx-auto">
        {loading ? <div className="h-[60vh] flex items-center justify-center"><Loader2 className="h-5 w-5 animate-spin" /></div>
          : !data ? <div className="h-[60vh] flex items-center justify-center text-sm text-zinc-500">This quotation link is invalid or has expired.</div> : <>
          <div className="flex flex-wrap justify-end items-center gap-2 mb-3 no-print">
            {data.status === "APPROVED_BY_CLIENT" && <span className="mr-auto text-sm font-medium text-emerald-700" data-testid="preview-approved-badge">Approved</span>}
            {data.status === "SENT_TO_CLIENT" && <Button onClick={approve} disabled={busy} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="preview-approve-button"><CheckCircle2 className="h-4 w-4 mr-2" />Approve quotation</Button>}
            <Button onClick={() => window.print()} className="bg-[#d32f2f] hover:bg-[#b71c1c] text-white" data-testid="preview-download-pdf"><Printer className="h-4 w-4 mr-2" />Print / Download PDF</Button>
          </div>
          <QuoteDocView data={data} />
        </>}
      </div>
    </div>
  );
}
